import * as React from 'react';
import { colors } from '../../../index';

const IconSearch = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 13 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.799 11.744L9.675 8.553a5.135 5.135 0 001.243-3.347C10.918 2.336 8.541 0 5.62 0 2.698 0 .321 2.335.321 5.206c0 2.87 2.377 5.206 5.298 5.206a5.307 5.307 0 003.036-.942l3.148 3.216a.692.692 0 00.498.208.69.69 0 00.479-.19.671.671 0 00.019-.96zM5.619 1.358c2.16 0 3.917 1.726 3.917 3.848S7.779 9.054 5.619 9.054 1.703 7.328 1.703 5.206 3.46 1.358 5.619 1.358z"
  }));
};

export default IconSearch;